import React from "react";
import PropTypes from 'prop-types';
import { Translate } from "../Translator";
import DatasourceBaseTextFields from "../Datasources/DatasourceBaseTextFields.jsx";

const DatasourceAfasProfit = (props) => {

    const Fields = [
        {Identifier:"ProfitServicesUrl", Translation:Translate("Profit Services URL"), Required:true},
        {Identifier:"InSiteUrl", Translation:Translate("InSite URL"), Required:true},
        {Identifier:"TokenXml", Translation:Translate("Token XML"), Required:true},
        {Identifier:"DatasourceVersion", Translation:"", Required:true, StaticValue:"3"}
    ]
    
    return (<DatasourceBaseTextFields SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} Fields={Fields} OnSetReady={props.OnSetReady}/>)

}

DatasourceAfasProfit.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceAfasProfit